import { DATA_ADAPTER } from '../../config/adapters';

/** Returns whether the backend responds (Firebase health check). Mock mode is always reachable. */
export async function pingServer(): Promise<boolean> {
  if (DATA_ADAPTER !== 'firebase') return true;
  try {
    const { healthCheck } = await import('../firebase/FunctionsService');
    await healthCheck();
    return true;
  } catch {
    return false;
  }
}
